'use strict'
const labelMixin = {
    methods: {
        // getVehicleLabel(vehicle, withNumber = true) {
        //     if (!vehicle) return ''
        //     const make = vehicle?.make?.name ?? ''
        //     const model = vehicle?.model?.name ?? ''
        //     const number = vehicle?.plate_number ?? ''
        //
        //     const name = [make, model].filter(Boolean).join(' ')
        //
        //     return withNumber
        //         ? [name, number].filter(Boolean).join(', ')
        //         : name
        // },

        getCustomerLabel(customer) {
            if (!customer) return ''

            let name = ''

            if (customer.type === 1) {
                const firstName = customer.first_name ?? ''
                const lastName = customer.last_name ?? ''

               name = [firstName, lastName].filter(Boolean).join(' ')
            } else if (customer.type === 2 && customer.company_name) {
                name = customer.company_name
            }

            return name
        },

        addressLine(item) {
            const parts = [
                item.address || item.address1,
                item.address2,
                item.city,
                item.state || item.region,
                item.postcode,
                item.country_name || item.country.name_en,
            ].filter(Boolean)

            return parts.join(', ')
        },

    }
}

export default labelMixin
